export default {
  // 搜索相關
  searchPlaceholder: "搜索地址/哈希/調證用戶ID",
  dataDetails: "數據詳情",

  // 頁面標題
  addressDetails: "地址詳情",
  contractDetails: "合約詳情",

  // 按鈕
  joinCanvas: "加入畫布",
  multiCurrencyCanvas: "多幣種畫布",
  singleCurrencyCanvas: "單幣種畫布",
  joinMonitor: "加入監控",
  browserView: "瀏覽器查看",

  // 對話框
  addMonitorTitle: "添加監控",

  // 消息提示
  copySuccess: "複製成功",
  addressNotFound: "沒有查出該地址",
  traceabilityDialog: {
    title: "溯源",
    strategyName: "策略名稱",
    strategyId: "策略編號",
    strategyRunTime: "策略運行時間",
    dependency: "依賴",
    hitRules: "命中規則",
  },
  missingTagDialog: {
    title: "標籤缺失",
    addressLabel: "地址",
    missingTagLabel: "缺失標籤",
    missingTagPlaceholder: "請選擇缺失標籤",
    platformCnLabel: "平台中文名稱",
    platformCnPlaceholder: "請選擇平台中文名稱",
    reasonLabel: "缺失原因",
    reasonPlaceholder: "請輸入缺失原因",
    cancel: "取消",
    confirm: "確認",
    addressEmpty: "地址為空",
    missingTagEmpty: "請選擇缺失標籤",
    platformCnEmpty: "請選擇平台中文名稱",
    reasonEmpty: "請輸入缺失原因",
    success: "添加成功",
  },
  correctionDialog: {
    title: "糾錯",
    tagNameLabel: "標籤名稱",
    tagNamePlaceholder: "請輸入標籤名稱",
    errorTypeLabel: "錯誤類型",
    errorTypePlaceholder: "請選擇錯誤類型",
    errorReasonLabel: "錯誤原因",
    errorReasonPlaceholder: "請輸入錯誤原因",
    cancel: "取消",
    confirm: "確認",
    tagNameEmpty: "請輸入標籤名稱",
    errorTypeEmpty: "請選擇錯誤類型",
    errorReasonEmpty: "請輸入錯誤原因",
    success: "提交成功",
  },
  // 交易對手相關
  rival: {
    // 搜索表單
    dataSource: "數據來源",
    transactionDirection: "交易方向",
    currency: "幣種",
    counterpartyPlaceholder: "請輸入交易對手地址",
    pleaseSelect: "請選擇",
    totalAmount: "總數量",
    transactionCount: "交易次數",
    minAmount: "最小數量",
    maxAmount: "最大數量",
    maxAmountValidation: "最大數量需≥最小數量",
    reset: "重置",
    search: "查詢",
    
    // 數據統計
    totalData: "共計",
    dataCount: "條數據",
    
    // 加載
    loading: "拼命加載中",
    
    // 表格列
    direction: "交易方向",
    counterparty: "交易對手",
    count: "交易次數",
    totalQuantity: "交易總數量",
    
    // 交易方向選項
    inflow: "充幣",
    outflow: "提幣",
    
    // 數據來源選項
    onChainData: "鏈上數據",
    platformInternal: "平台內部",
    
    // 空數據提示
    emptyText: "當前調證文件中未解析到充提交易數據",
    
    // 下載
    downloadDetails: "下載數據明細",
  },
};
